import { useState } from 'react';

export const useTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [leaveTab, setLeaveTab] = useState(0);
  const [direction, setDirection] = useState('');

  const setTab = (_: any, tabNumber: number): void => {
    if (activeTab !== tabNumber) {
      setDirection(activeTab < tabNumber ? 'ltr' : 'rtl');
      setLeaveTab(activeTab);
      setActiveTab(tabNumber);
    }
  };

  return { activeTab, leaveTab, direction, setTab };
};
